module.exports = __webpack_public_path__ + "img/album06_04.31ac1953.jpg";